import { UNIT } from '../../../settings/settings';

export const defaultAllowedUnits = [UNIT.DOLLARS, UNIT.PERCENT, UNIT.SHARES];
